import useSWR from 'swr';
import { useIntl } from 'react-intl';
import { useConfig } from '@packages/shared';

import type { UspData, UspRootItem } from './types';
import { getUspDataEndpoint } from './getUspData';

const fetcher = (endpoint: string) => (): Promise<UspData> =>
  fetch(endpoint).then((res) => {
    if (!res.ok) {
      // throw error when response status not ok -> error boundary catches and logs the error
      throw new Error(`Endpoint: ${res.url} - Status ${res.status}: ${res.statusText}`);
    }
    return res.json();
  });

const mapData = (uspItem: UspRootItem) => ({
  ...uspItem,
  children: Object.values(uspItem.children).filter(Boolean),
});

export const useUspData = (): { data: UspData | undefined; endpoint: string } => {
  const { locale } = useIntl();
  const { clientId } = useConfig();
  const endpoint = getUspDataEndpoint(clientId, locale);
  const cacheKey = `usp-data-${clientId}-${locale}`;
  const { data } = useSWR<UspData>(cacheKey, fetcher(endpoint), {
    keepPreviousData: true,
    revalidateIfStale: true,
    revalidateOnMount: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  return { data: data ? [mapData(data['0']), mapData(data['1'])] : undefined, endpoint };
};
